<div class="conteneur"
  *ngIf="infosFoyer && userData && listKeysFieldForm && ((showMandatSepaCard && mandatsSepa || !showMandatSepaCard)) ; else loader">
  <div class="fx-direction-row fx-wrap">

    <mat-card appearance="raised" class="card" *ngIf="userData">
      <mat-card-header class="card-header fx-between-center">
        <mat-card-title class="fx-direction-row fx-start-center">
          <i *ngIf="userData.sexe === 'M'" class="icodomino-man"></i>
          <i *ngIf="userData.sexe === 'F'" class="icodomino-woman"></i>
          <span style="margin-left: 8px;">Moi</span>
        </mat-card-title>
        <button mat-mini-fab color="primary" matTooltip="Voir" routerLink="/account/user">
          <mat-icon>visibility</mat-icon>
        </button>
      </mat-card-header>
      <mat-card-content class="card-content">
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Nom prénom</span>
            <span class="info-value">
              {{ userData.civilite }} {{ userData.nom | uppercase }} {{ userData.prenom }}
              <span *ngIf="userData.situationFamiliale" class="info-sub">({{ userData.situationFamilialeName }})</span>
            </span>
          </div>

          <div class="info-item">
            <span class="info-label">Adresse</span>
            <span class="info-value">
              {{ userData.numRue }} {{ userData.rue }}
              <span *ngIf="userData.rue2"><br>{{ userData.rue2 }}</span>
              <span *ngIf="userData.rue3"><br>{{ userData.rue3 }}</span>
              <br>{{ userData.codePostal }} {{ userData.ville }}
            </span>
          </div>

          <div class="info-item">
            <span class="info-label">Contact</span>
            <div class="info-value">
              <div class="info-line fx-direction-row fx-start-end">
                <mat-icon>alternate_email</mat-icon>
                {{userData.email}}
              </div>
              <div *ngIf="userData.telephone" class="info-line fx-direction-row fx-start-center">
                <mat-icon>local_phone</mat-icon>
                {{ userData.telephone }}
              </div>
              <div *ngIf="userData.telMobile" class="info-line fx-direction-row fx-start-center">
                <mat-icon>phone_android</mat-icon>
                {{ userData.telMobile }}
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="raised" class="card" *ngIf="userData">
      <mat-card-header class="card-header fx-direction-row fx-between-center">
        <mat-card-title class="fx-direction-row fx-start-center">
          <i *ngIf="conjoint && conjoint.sexe === 'M'" style="margin-right: 5px;" class="icodomino-man"></i>
          <i *ngIf="conjoint && conjoint.sexe === 'F'" style="margin-right: 5px;" class="icodomino-woman"></i>
          <span>{{ 'foyer.other_responsible'|trans }}</span>
        </mat-card-title>
        <button *ngIf="conjoint" mat-mini-fab color="primary" [matMenuTriggerFor]="menuConjoint">
          <mat-icon>{{editFoyer ? 'edit' : 'visibility'}}</mat-icon>
        </button>
      </mat-card-header>

      <mat-menu class="mat-menu-conjoint" #menuConjoint="matMenu" xPosition="before">
        <button *ngFor="let formPart of adulteFormSteps" mat-menu-item
          (click)="openForm('/conjoint',formPart.stepName)">
          <mat-icon color="primary">{{editFoyer ? 'edit' : 'visibility'}}</mat-icon>
          {{formPart.label}}
        </button>
      </mat-menu>

      <mat-card-content class="card-content" *ngIf="conjoint">
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Nom prénom</span>
            <span class="info-value">
              {{ conjoint.civilite }} {{ conjoint.nom | uppercase }} {{ conjoint.prenom }}
              <span *ngIf="infosFoyer.situationFamiliale" class="info-sub">({{ infosFoyer.situationFamilialeName
                }})</span>
            </span>
          </div>

          <div class="info-item">
            <span class="info-label">Adresse</span>
            <span class="info-value">
              {{ conjoint.numRue }} {{ conjoint.rue }}
              <span *ngIf="conjoint.rue2"><br>{{ conjoint.rue2 }}</span>
              <span *ngIf="conjoint.rue3"><br>{{ conjoint.rue3 }}</span>
              <br>{{ conjoint.codePostal }} {{ conjoint.ville }}
            </span>
          </div>

          <div class="info-item">
            <span class="info-label">Contact</span>
            <div class="info-value">
              <div *ngIf="conjoint.email" class="info-line fx-direction-row fx-start-end">
                <mat-icon>alternate_email</mat-icon>
                {{conjoint.email}}
              </div>
              <div *ngIf="conjoint.telephone" class="info-line fx-direction-row fx-start-center">
                <mat-icon>local_phone</mat-icon>
                {{ conjoint.telephone }}
              </div>
              <div *ngIf="conjoint.telMobile" class="info-line fx-direction-row fx-start-center">
                <mat-icon>phone_android</mat-icon>
                {{ conjoint.telMobile }}
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions class="fx-direction-row fx-center-center" *ngIf="!conjoint">
        <button mat-fab color="primary" style="margin: 10px;" matTooltip="Ajouter un responsable"
          [routerLink]="addBtnUrl" [disabled]="!editFoyer || !addBtnUrl">
          <mat-icon>add</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>

    <mat-card appearance="raised" *ngFor="let step of foyerFormSteps" class="card">
      <mat-card-header class="card-header fx-direction-row fx-between-center">
        <mat-card-title class="fx-direction-row fx-start-center">
          <app-icon *ngIf="step.stepName === 'coordinates'" style="margin-right: 5px; padding-top: 3px" type="do"
            icon="courrier">
          </app-icon>
          <mat-icon *ngIf="step.stepName === 'complement'" style="margin-right: 5px;">assignment</mat-icon>
          <span>{{ step.label }}</span>
        </mat-card-title>
        <button mat-mini-fab color="primary" [matTooltip]="editFoyer ? 'Voir/Modifier' : 'Voir'"
          (click)="openForm('foyer',step.stepName)">
          <mat-icon>{{editFoyer ? 'edit' : 'visibility'}}</mat-icon>
        </button>
      </mat-card-header>
      <mat-card-content class="card-content">
        <ng-container *ngIf="step.stepName === 'coordinates'" [ngTemplateOutlet]="coordinates"></ng-container>
        <ng-container *ngIf="step.stepName === 'complement'" [ngTemplateOutlet]="complement"></ng-container>
      </mat-card-content>
    </mat-card>

    <!-- Mandats SEPA -->
    <mat-card appearance="raised" *ngIf="showMandatSepaCard" class="card-mandat-sepa">
      <mat-card-header class="card-header fx-direction-row fx-between-center">
        <mat-card-title class="fx-direction-row fx-start-center">
          <app-icon style="margin-right: 5px; padding-top: 3px" type="do" icon="mandat-sepa">
          </app-icon> Mandats SEPA
        </mat-card-title>
        <button mat-mini-fab color="primary" matTooltip="Modifier" routerLink="/account/mandats-sepa">
          <mat-icon>edit</mat-icon>
        </button>
      </mat-card-header>
      <mat-card-content class="card-content">
        <div class="info-grid"
          [ngStyle]="{'grid-template-columns': mandatsSepa.length > 1 ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)'}">
          <div class="info-item" *ngFor="let mandat of mandatsSepa">
            <div class="fx-direction-row fx-between-start">
              <div class="info-value">
                <div class="info-line">
                  <label>N° Mandat (RUM) :</label>
                  {{ mandat.numRUM ? mandat.numRUM : '[Déterminé à la validation]' }}
                </div>
                <div class="info-line"><label>Créancier :</label> {{mandat.creancier}}
                </div>
                <div class="info-line">
                  <label>IBAN :</label> {{mandat.iban}}
                </div>
                <div class="info-line">
                  <label>BIC :</label> {{mandat.bic}}
                </div>
              </div>
              <div class="fx-direction-row fx-between-center" style="margin-bottom: 8px;">
                <app-icon *ngIf="mandat.idSEPAMandat > 0 && mandat.estActif" type="mat" icon="check_circle"
                  class="success-color" matTooltip="Actif"></app-icon>
                <app-icon *ngIf="mandat.idSEPAMandat > 0 && !mandat.estActif" type="mat" icon="block" class="warn"
                  matTooltip="Désactivé"></app-icon>
                <app-icon *ngIf="mandat.idSEPAMandat < 0 && mandat.estActif" type="mat" icon="hourglass_top"
                  class="accent" matTooltip="En attente"></app-icon>
              </div>
            </div>
            @if(mandat.portailEnregistrementExist){
            <div class="info-line status-message fx-end">
              <em *ngIf="mandat.idSEPAMandat > 0 && !mandat.estActif">Désactivation en attente de traitement.</em>
              <em *ngIf="mandat.idSEPAMandat < 0 && mandat.estActif">Activation en attente de traitement.</em>
            </div>
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<ng-template #complement>
  <div style="height: 100%;" class="fx-direction-col fx-justify-content-between">
    <div class="info-grid">
      <div class="info-item" *ngIf="infosFoyer.situationFamiliale && listKeysFieldForm.includes('situationFamiliale')">
        <span class="info-label">Situation familiale</span>
        <span class="info-value">{{ infosFoyer.situationFamilialeName }}</span>
      </div>
      <div class="info-item" *ngIf="infosFoyer.numAllocataire && listKeysFieldForm.includes('numAllocataire')">
        <span class="info-label">N° Allocataire</span>
        <span class="info-value">{{infosFoyer.numAllocataire}}</span>
      </div>
      <div class="info-item" *ngIf="infosFoyer.nbTotalEnfants && listKeysFieldForm.includes('nbTotalEnfants')">
        <span class="info-label">Nombre total d'enfants</span>
        <span class="info-value">{{infosFoyer.nbTotalEnfants}}</span>
      </div>
      <div class="info-item" *ngIf="infosFoyer.nbEnfantsACharge && listKeysFieldForm.includes('nbEnfantsACharge')">
        <span class="info-label">Nombre d'enfants à charge</span>
        <span class="info-value">{{infosFoyer.nbEnfantsACharge}}</span>
      </div>
    </div>
    <div class="fx-direction-row fx-center-center" style="margin-top: 5px;">
      <mat-icon class="more-horiz">more_horiz</mat-icon>
    </div>
  </div>
</ng-template>

<ng-template #coordinates>
  <div class="info-grid">
    <div class="info-item">
      <span class="info-label">Nom de famille</span>
      <span class="info-value">
        {{ infosFoyer.civilite }}
        {{ infosFoyer.nomFamille | uppercase }}
      </span>
    </div>

    <div class="info-item">
      <span class="info-label">Adresse</span>
      <span class="info-value">
        {{ infosFoyer.numRue }} {{ infosFoyer.rue }}
        <span *ngIf="infosFoyer.rue2"><br>{{ infosFoyer.rue2 }}</span>
        <span *ngIf="infosFoyer.rue3"><br>{{ infosFoyer.rue3 }}</span>
        <br>{{ infosFoyer.codePostal }} {{ infosFoyer.ville }}
      </span>
    </div>

    <div class="info-item" *ngIf="infosFoyer.telephone2 || infosFoyer.telephone">
      <span class="info-label">Contact</span>
      <div class="info-value">
        <div class="info-line fx-direction-row fx-start-center" *ngIf="infosFoyer.telephone">
          <mat-icon>local_phone</mat-icon>
          {{ infosFoyer.telephone }}
        </div>
        <div class="info-line fx-direction-row fx-start-center" *ngIf="infosFoyer.telephone2">
          <mat-icon>phone_android</mat-icon>
          {{ infosFoyer.telephone2 }}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #loader>
  <app-loader [message]="'Chargement des données...'" class="margin"></app-loader>
</ng-template>